module.exports = __webpack_public_path__ + "media/en_gb_s2_Ella.d05d4b4a.mp3";